import { useEffect, useRef } from "react";
import {
  CUSTOM_EVENT_TYPE_READER_ACTION,
  CUSTOM_EVENT_TYPE_READER_PLAY
} from "@/shared/utils/reader/constants";

const useListenReaderCustomEventTypes = (handlers) => {
  const refHandlers = useRef();
  refHandlers.current = handlers;

  useEffect(() => {
    const listenerPlay = () => {
      if (refHandlers.current.playEventHandler) {
        refHandlers.current.playEventHandler();
      }
    };

    const listenerAction = (e) => {
      if (refHandlers.current.actionEventHandler) {
        refHandlers.current.actionEventHandler(e.detail.action, e.detail.value);
      }
    };

    // Listens for custom event type, that implements the access to {handleAction} method.
    // Is used in the "system.saga.js".
    window.addEventListener(CUSTOM_EVENT_TYPE_READER_ACTION, listenerAction);

    // Listens for the global event, that calls {handlePlayClick}.
    // Is done so, because this hook is used in the "Reader" context only.
    // But "Header" has the play button, that should behave the way same as the Reader play btn.
    // PS: Another approach could be to "portal" (React Portals) play button to Header.
    window.addEventListener(CUSTOM_EVENT_TYPE_READER_PLAY, listenerPlay);

    return () => {
      window.removeEventListener(CUSTOM_EVENT_TYPE_READER_PLAY, listenerPlay);
      window.removeEventListener(CUSTOM_EVENT_TYPE_READER_ACTION, listenerAction);
    };
  }, []);
};
export default useListenReaderCustomEventTypes;
